{
  "colorFormat": "פורמט צבע",
  "hex": "משושה",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
